import React from "react";
import { Steps } from "antd";
import {
  CarOutlined,
  CheckCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { withNamespaces } from "react-i18next";

const { Step } = Steps;
const description = "here";
const Stepper = ({ status, t, shippingStatus }) => {
  const statusMap = {
    "Driver Pending": 0,
    "Out for Delivery": 1,
    Complete: 2,
  };
  const orderShippingStatus = {
    "go to branch": t("Driver accepted the order."),
    "pick up": t("Driver picking up order."),
    navigate: t("Driver picked up the order and is on the way."),
    deliver: t("Delivering your order."),
  };

  return (
    <div className="mt-5 p-2">
      <Steps current={statusMap[status]} size="small">
        <Step
          title={t("Driver Pending")}
          description={statusMap[status] !== 0 ? t("Accepted") : ""}
          icon={
            statusMap[status] === 0 ? (
              <LoadingOutlined />
            ) : (
              <CheckCircleOutlined />
            )
          }
        />
        <Step
          title={t("Out for Delivery")}
          icon={<CarOutlined />}
          description={
            statusMap[status] === 1 ? (
              <span style={{ color: "rgba(0, 0, 0, 0.45)" }}>
                {orderShippingStatus[shippingStatus?.toLowerCase()] || ""}
              </span>
            ) : (
              ""
            )
          }
        />

        <Step title={t("Complete")} icon={<CheckCircleOutlined />} />
      </Steps>
    </div>
  );
};

export default withNamespaces()(Stepper);
